import React from "react";

import { MenuItem } from "@material-ui/core";
import type { TFunction } from "i18next";

export const MinutesMenuItem = (numMinutes: number, t: TFunction) => (
    <MenuItem value={numMinutes * 60}>{t("Entities.ScheduleException.MinutesFormat", { count: numMinutes })}</MenuItem>
);

export const HoursMenuItem = (numHours: number, t: TFunction) => (
    <MenuItem value={numHours * 3600}>{t("Entities.ScheduleException.HoursFormat", { count: numHours })}</MenuItem>
);
